/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Marker_Add_SplitInputs */

const en_ui_studio_marker_add_split = /** @type {(inputs: Ui_Studio_Marker_Add_SplitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add split point`)
};

const de_ui_studio_marker_add_split = /** @type {(inputs: Ui_Studio_Marker_Add_SplitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilungspunkt hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add split point" |
*
* @param {Ui_Studio_Marker_Add_SplitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_marker_add_split = /** @type {((inputs?: Ui_Studio_Marker_Add_SplitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Marker_Add_SplitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_marker_add_split(inputs)
	return de_ui_studio_marker_add_split(inputs)
});